module.exports = __webpack_public_path__ + "img/1m.36c7d47d.png";